import { getZervantContactType } from '@views/externalInvoices/routes/InvoiceEditor/utils/getZervantContactType'

import { Language } from '../../../../types/language'
import { ContactPerson } from '../../../contacts/types/contactPerson'
import { InvoiceForm } from '../../types/invoiceForm/invoiceForm'
import { InvoicePayloadContact } from '../../types/invoicePayload/invoicePayloadContact'

interface GetReceiverPayloadOptions {
  formValues: InvoiceForm
  invoiceLanguage: Language
  receiverContactPerson?: ContactPerson
}

export const getReceiverPayload = ({
  formValues,
  invoiceLanguage,
  receiverContactPerson,
}: GetReceiverPayloadOptions): InvoicePayloadContact | undefined => {
  const { receiver } = formValues

  if (!receiver || !receiver?.externalId) {
    return undefined
  }

  const {
    addressLine2,
    cityText,
    contactNo,
    countryId,
    ean,
    eInvoiceScheme,
    email,
    externalId,
    id,
    isSalesTaxExempt,
    name,
    paymentTermsDays,
    phone,
    registrationNo,
    street,
    type,
    vatNo,
    zipcodeText,
  } = receiver || {}

  const receiverAddress = {
    city: cityText,
    country: countryId,
    pobox: zipcodeText,
    streetAddress1: street,
    streetAddress2: addressLine2 || '',
  }

  const receiverEInvoiceAddress = {
    address: ean,
    networkOperatorId: null,
    networkType: null,
    scheme: eInvoiceScheme,
  }

  return {
    address: receiverAddress,
    businessId: registrationNo,
    companyName: name,
    customerNumber: Number(contactNo || ''),
    customerType: getZervantContactType(type),
    displayName: name,
    eInvoiceAddress: receiverEInvoiceAddress,
    email: email || '',
    // externalId in Zervant is Billy's id and Zervant's id
    // is Billy's externalId, that's why we switch types here
    externalContactId: id,
    firstName: receiverContactPerson?.firstName || '',
    id: Number(externalId || ''),
    isPublicEntity: formValues.receiver?.publicEntityRoutingEnabled,
    isSalesTaxExempt,
    language: invoiceLanguage,
    lastName: receiverContactPerson?.lastName || '',
    paymentTerm: paymentTermsDays,
    phoneNumberWork: phone || '',
    vatNumber: vatNo,
  }
}
